import React, { useState} from "react";
// import imgProductLakay from './images/md3.jpg';
import {activatorUserAdding} from "../../auth";
import { laguangeElakay } from "../../pageInside/dataElakay";
// import "./sliderProduct.css"
// import { Seller, } from "../../pageInside/Rolle"
import FormAddress from "../../pageInside/formInput/formAddress";

const AddAddressUserAssociate = (props) => {
    const {
        setPagesUser,
        bnTelephone,
        setUserInfo,
        token,
        infoSource,
        phoneUser,
        fullName
            } = props

            
    let userValue = {
        firstName: fullName.firstname? fullName.firstname : "",
        lastName:  fullName.lastname? fullName.lastname : "",
        shopName: null,
        tel: "",
        Address1: "", 
        Address2: "",
        city: '',
        State: '',
        postalCode: '',
        country: '',
        latitude: "",
        longitude: "",
        error: "",
    }

    const [values, setValues] = useState(userValue);
    // Country / ZIP / State / City are handled by FormAddress's shared
    // address location fields (no country file download here anymore).

    const clickSubmit = event => {

        event.preventDefault();
           
        activatorUserAdding(token, 'address',  values, true).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                setValues(userValue)
                setUserInfo(data)
                setPagesUser(bnTelephone)
            }
        });
    };

        return <FormAddress
                clickSubmit={clickSubmit}
                values ={values} 
                setValues={setValues}
                infoSource={infoSource}
                phoneUser={phoneUser}
                laguangeElakay ={laguangeElakay}
                btnCancel={false}
                />

   
};

export default AddAddressUserAssociate;
